import { Link, useParams } from 'react-router-dom'
import { Wallet } from '@/entities/wallet'
import { ConfigStore, LangStore } from '@/shared/model/store'
import { Button } from '@/shared/ui'
import CreateNpo from './create-npo'
import { ThemeToggle } from '@/features/theme-toggle'
import { LangToggle } from '@/features/lang-toggle/ui/lang-toggle'
import NPOPage from './npo-page'
import { ExternalLink } from 'lucide-react'

const CreateNpoPage = () => {
	const { domain } = ConfigStore()
	const { id } = useParams()
	const { langPack } = LangStore()

	const npo_address: `0x${string}` | undefined = id as `0x${string}`

	return (
		<div className='container pt-6'>
			<div className='mb-6 flex flex-row flex-wrap items-center justify-between gap-4 px-4 py-6 shadow-lg'>
				<div className='flex items-center gap-2'>
					<span className='text-[20px] font-bold'>{langPack('npo.pluralTitle')}</span>
				</div>
				<div className='flex gap-4'>
					<ThemeToggle />
					<LangToggle />
					<Link to='/'>
						<Button>
							<ExternalLink size={16} className='mr-2' />
							{`${domain.toUpperCase()}`}
						</Button>
					</Link>
					<div className='w-auto'>
						<Wallet />
					</div>
				</div>
			</div>
			{!npo_address ? <CreateNpo /> : <NPOPage />}
		</div>
	)
}

export default CreateNpoPage
